<template>
  <li class="accordion__item">
    <div
      class="accordion__trigger"
      :class="{ accordion__trigger_active: visible }"
      @click="open"
    >
      <!-- This slot will handle the title/header of the accordion and is the part you click on -->
      <slot style="color: red" name="accordion-trigger"></slot>
    </div>

    <transition
      name="accordion"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end"
    >
      <div class="accordion__content" v-show="visible">
        <ul>
          <!-- This slot will handle all the content that is passed to the accordion -->
          <slot name="accordion-content"></slot>
          <div v-if="htmlContent" v-html="htmlContent"></div>
        </ul>
      </div>
    </transition>
  </li>
</template>


<script>
export default {
  props: {
    forceActive: {
      required: false,
    },
    disableToggle: {
      required: false,
    },
    htmlContent: {
      required: false,
    },
  },
  inject: ["Accordion"],
  data() {
    return {
      index: null,
      expanded: this.forceActive,
    };
  },
  mounted() {
    this.$root.$on("open-accordion-payment", () => {
      if (!this.expanded) this.Accordion.active = null;
    });
  },
  computed: {
    visible() {
      return this.index == this.Accordion.active || this.expanded;
    },
  },
  methods: {
    open() {
      if (this.disableToggle) return;

      if (this.visible) {
        this.Accordion.active = null;
        this.expanded = false;
      } else {
        this.Accordion.active = this.index;
      }
      this.$emit("open");
    },
    start(el) {
      el.style.height = el.scrollHeight + "px";
    },
    end(el) {
      el.style.height = "";
    },
  },
  created() {
    this.index = this.Accordion.count++;
  },
  watch: {
    forceActive(newVal) {
      this.expanded = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion__item {
  cursor: pointer;
  padding: 10px 20px 10px 40px;
  border-bottom: 1px solid #ebebeb;
  position: relative;
}

.accordion__trigger {
  display: flex;
  justify-content: space-between;
}

.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}
</style>
